import type { GetStaticProps } from "next";
import ImageBanner from "@components/ImageBanner";
import type { pageTitle, pageContent } from "@lib/types";
import { CarouselBasic } from "@components/Carousels";
import {
  getPageTitleContentFromDB,
  getPageContentFromDB,
} from "@lib/pagequerys";
import {
  Container,
  Heading,
  LinkComponent,
  Section,
  Text,
} from "@components/SectionComponents";

export const getStaticProps: GetStaticProps = async () => {
  // page_id in DB
  const pageIdDB: number = 36;

  // query DB for page title data
  const pageTitle: pageTitle = await getPageTitleContentFromDB(pageIdDB);

  // Array of pageContent - query DB for pageContent data
  const pageContent: pageContent[] = await getPageContentFromDB(pageIdDB);

  return {
    props: {
      pageTitle,
      pageContent,
    },
  };
};

// Home Page takes a pageTitle, and pageContent array
export default function Page({
  pageTitle,
  pageContent,
}: {
  pageTitle: pageTitle;
  pageContent: pageContent[];
}) {
  return (
    <>
      <ImageBanner title={pageTitle} />

      {/* Section 0 */}
      <Section colour="brown">
        <Container>
          <Heading h1={true} content={{ title: pageContent[0].title }} />
          <Text content={pageContent[0].text} />
        </Container>
      </Section>

      {/* Section 1 */}
      <Section colour="cream">
        <Container longer="bottom">
          <Heading
            content={{
              title: pageContent[1].title,
              subtitle: pageContent[1].subtitle,
            }}
          />
          <Text content={pageContent[1].text} />
          <LinkComponent link1={pageContent[1].link1} />
        </Container>
      </Section>

      {/* Section 2 */}
      <Section colour="dark">
        <CarouselBasic images={pageContent[2].carouselImages} overlap="top" />
        <Container longer="both">
          <Heading content={{ title: pageContent[2].title }} />
          <Text content={pageContent[2].text} />
          <LinkComponent link1={pageContent[2].link1} />
        </Container>
      </Section>

      {/* Section 3 */}
      <Section colour="white">
        <CarouselBasic images={pageContent[3].carouselImages} overlap="top" />
        <Container longer="top">
          <Heading content={{ title: pageContent[3].title }} />
          <Text content={pageContent[3].text} />
          <LinkComponent link1={pageContent[3].link1} />
        </Container>
      </Section>
    </>
  );
}
//Meta Data
Page.title = "Events";
Page.description =
  "Host your special occasion including wedding, birthday and corporate celebrations in unique locations throughout The Crocodile Hunter Lodge, Warrior Restaurant & Bar and Ironbark Paddock.";
